var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_59)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6753 2.40753e-08C8.97284 0.000145054 7.29514 0.407392 5.78213 1.18776C4.26912 1.96814 2.96467 3.09901 1.97762 4.48602C0.990567 5.87304 0.349534 7.47598 0.107999 9.16111C-0.133535 10.8462 0.0314335 12.5647 0.589142 14.1731C1.14685 15.7815 2.08113 17.2333 3.31402 18.4072C4.54692 19.5811 6.04269 20.4432 7.67653 20.9215C9.31037 21.3998 11.0349 21.4804 12.7063 21.1567C14.3776 20.833 15.9473 20.1143 17.2844 19.0606L21.8714 23.6474C22.1083 23.8762 22.4256 24.0028 22.7549 24C23.0842 23.9971 23.3992 23.865 23.6321 23.6321C23.865 23.3993 23.9971 23.0843 24 22.7549C24.0028 22.4256 23.8762 22.1084 23.6474 21.8715L19.0604 17.2847C20.3014 15.7105 21.074 13.8187 21.29 11.8259C21.506 9.83307 21.1565 7.81971 20.2816 6.01622C19.4067 4.21274 18.0417 2.69199 16.3428 1.62803C14.6439 0.564065 12.6798 -0.000134569 10.6753 2.40753e-08ZM2.51113 10.6758C2.51113 8.51058 3.37128 6.43408 4.90235 4.90307C6.43342 3.37206 8.50999 2.51194 10.6753 2.51194C12.8405 2.51194 14.9171 3.37206 16.4482 4.90307C17.9792 6.43408 18.8394 8.51058 18.8394 10.6758C18.8394 12.8409 17.9792 14.9174 16.4482 16.4484C14.9171 17.9795 12.8405 18.8396 10.6753 18.8396C8.50999 18.8396 6.43342 17.9795 4.90235 16.4484C3.37128 14.9174 2.51113 12.8409 2.51113 10.6758Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterSearch);
export default __webpack_public_path__ + "static/media/footer_search.668f3523b6a315de05a781351b1ab21e.svg";
export { ForwardRef as ReactComponent };